import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import _ from 'lodash';
import RCore from 'RCore';
import eventify from 'Eventify';
import SMTeamLogo from '../SMTeamLogo';
import DateFormatted from '../DateFormatted';
const i18Common = require('../../../../i18/i18.Common');
const i18 = RCore.getTranslation.bind({ dict: i18Common });

import { Container, Rows, LatestFormRow, H2HRow } from './H2HTableSimple';

const Flex = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 0;

    .score {
        font-size: 70px;
        line-height: 1em;
        white-space: nowrap;
        font-weight: bold;
        min-width: 190px;
        text-align: center;
        color: ${props => props.theme.content.accentTextColor};
    }
`;
const LogoWrapper = styled.div`
    width: calc(50% - 60px);
    text-align: center;

    .rank {
        padding-bottom: 5px;
        padding-top: 10px;
        display: block;
        text-align: center;
    }
`;

const RowsWrapper = styled.div`
    .stat-row {
        position: relative;
        padding: 6px 0;
        justify-content: space-between;
        margin-top: 0;

        .val {
            color: ${props => props.theme.statTableTextColor};
        }
        .val {
            width: calc(50% - 60px);
            text-align: center;
            flex-basis: initial;
            flex-grow: initial;
            font-size: 30px;
            background: transparent !important;

            &.tar {
                text-align: center;
            }
        }
        .label {
            color: ${props => props.theme.statTableLabelTextColor};
            flex-grow: 1;
            font-size: 14px;
            line-height: 1.4em;
            text-align: center;
            width: 1px;
            padding: 0 5px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: normal;
            text-transform: uppercase;
            min-width: 190px;
            background: transparent !important;
        }
    }
`;

const Status = styled.div`
    text-align: center;
    text-transform: uppercase;
    font-weight: 700;
    position: relative;
    ${props => (props.status === 'inprogress' ? `color: ${props.theme.positiveColor};` : '')};
`;

const StatusInner = styled.div`
    text-align: center;
`;

const HeaderWrapper = styled.div`
    background: ${props => props.theme.content.backgroundColor};
    padding-top: 0;
    position: relative;
    z-index: 1;
`;
const StartInfo = styled.div`
    text-align: center;
    font-size: 22px;
    line-height: 28px;
    text-transform: uppercase;
    min-width: 190px;
    text-align: center;

    strong {
        font-size: 18px;
    }
`;

const FormWrapper = styled.div`
    ul {
        width: calc(100% - 60px);
        text-align: center;
        transform: none;
    }
    .title {
        min-width: 190px !important;
        display: inline-block;
        text-align: center;
    }

    > div {
        margin-bottom: 0;
    }
    .stat-item {
        background: transparent;
        margin: 0 1px;
        font-size: 24px;
        width: auto;
    }
    .stat-item_draw {
        color: ${props => props.theme.wdl.draw};
    }
    .stat-item_win {
        color: ${props => props.theme.wdl.win};
    }
    .stat-item_loss {
        color: ${props => props.theme.wdl.loss};
    }
`;

const H2HWrapper = styled.div`
    > div {
        margin-top: 0;
    }

    &.__c__b_h2hwrapper {
        .title {
            background-color: transparent !important;
        }
    }
`;

const MatchDate = styled.div`
    font-size: 35px;
    font-weight: bold;
`;

const WrappedRows = props => {
    return (
        <RowsWrapper className="__c__b_rows">
            <Rows {...props} />
        </RowsWrapper>
    );
};

const WrappedH2H = props => {
    return (
        <H2HWrapper className="__c__b_h2hwrapper">
            <H2HRow {...props} />
        </H2HWrapper>
    );
};

const WrapperForm = (props, ctx) => {
    const lang = _.get(ctx, 'info.lang', 'en');

    return (
        <FormWrapper>
            <LatestFormRow {...props} title={i18('form', lang)} />
        </FormWrapper>
    );
};

const Header = ({ event, rankInfo, ...props }, ctx) => {
    const {
        homeShortName,
        awayShortName,
        homeId,
        awayId,
        score: { home, away },
        statusType,
    } = event;
    const lang = _.get(ctx, 'info.lang', 'en');
    event = eventify(event);
    return (
        <HeaderWrapper>
            <div>
                {(event.isLive() || event.isFinished()) && (
                    <Status status={statusType}>
                        <StatusInner>
                            <div style={{ fontSize: 23, lineHeight: '1em', padding: '5px' }} className="__c__b2_status">
                                <span className="__c__c2_status">
                                    {event.isLive() && event.isHT() && i18('ht', lang)}
                                    {event.isLive() && !event.isHT() && i18('live', lang)}
                                    {event.isFinished() && i18('finished', lang)}
                                </span>
                            </div>
                            {event.isLive() &&
                                !event.isHT() && (
                                    <div style={{ fontSize: 20, lineHeight: 1, whiteSpace: 'nowrap' }}>
                                        `{event.getMinutes()} {i18('min', lang)}.
                                    </div>
                                )}
                        </StatusInner>
                    </Status>
                )}
                <Flex>
                    <LogoWrapper className="__c__c1_logo">
                        <SMTeamLogo height={60} fontSize={42} teamId={homeId} teamShortName={homeShortName} />
                        <div className="rank-wrap">
                            {rankInfo &&
                                rankInfo.home && (
                                    <div className="rank">
                                        <b>#{rankInfo.home.rank}</b> ({rankInfo.home.points} {i18('points', lang)})
                                    </div>
                                )}
                        </div>
                    </LogoWrapper>
                    {!event.isComming() ? (
                        <div className="score">
                            {home} - {away}
                        </div>
                    ) : (
                        <StartInfo>
                            <strong>{i18('matchstart', lang)}</strong>
                            <MatchDate>
                                <DateFormatted date={event.startDate} type="TIME" el="div" />
                            </MatchDate>
                        </StartInfo>
                    )}

                    <LogoWrapper className="__c__c1_logo">
                        <SMTeamLogo height={60} fontSize={42} teamId={awayId} teamShortName={awayShortName} />
                        <div className="rank-wrap">
                            {rankInfo &&
                                rankInfo.away && (
                                    <div className="rank">
                                        <b>#{rankInfo.away.rank}</b> ({rankInfo.away.points} {i18('points', lang)})
                                    </div>
                                )}
                        </div>
                    </LogoWrapper>
                </Flex>
            </div>
        </HeaderWrapper>
    );
};

const HeaderMinimized = Header;
Header.contextTypes = HeaderMinimized.contextTypes = {
    info: PropTypes.object,
    moment: PropTypes.func,
};

export default {
    Container,
    Header: Header,
    HeaderMinimized,
    LatestFormRow: WrapperForm,
    Rows: WrappedRows,
    H2HRow: WrappedH2H,
};



/** WEBPACK FOOTER **
 ** ../src/widgets/components/sm/views/h2h/H2HStyle4.js
 **/